export const SLUG_REGEX = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/
export const DOMAIN_REGEX = /^(?!:\/\/)([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)+\.?)$/

export const HTTPS_PREFIX = 'https://'
export const PORTAL_DOMAIN = 'stackerportal.com'
